export default __webpack_public_path__ + "static/media/NEAS0670.34I-40919_-24211_0.00f0759a.jpg";